<template>
    <div  v-loading="loading">
        <el-button type="primary" @click.native="addInvoicebut" class="buttonFloat">新增发票</el-button>
        <div class="invoiceTable">
          <el-table
            :data="invoiceList"
            stripe
            style="width: 100%">
            
            <el-table-column
              prop="date"
              label="发票类型"
              align="center"
              width="100">

              <template slot-scope="scope">
                  <div v-if="(scope.row.type == 1 ? true : false)">普通发票</div>
                  <div v-if="(scope.row.type == 2 ? true : false)">电子发票</div>
                  <div v-if="(scope.row.type == 3 ? true : false)">增值税发票</div>
                    <!-- <el-button type="success" size="mini" round @click="dialogVisibleLock(scope.row)">解锁</el-button>
                    <el-button type="primary" size="mini" round @click="dialogVisibleRecharge(scope.row)">充值</el-button> -->
                  <div>{{scope.row.tin ? "企业" : "个人"}}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="telephone"
              label="用户手机号"
              align="center"
              width="120">
            </el-table-column>
            <el-table-column
              prop="title"
              label="发票抬头"
              align="center"
              width="100">
            </el-table-column>
            <el-table-column
              prop="tin"
              label="纳税人识别号"
              align="center"
              width="180">
            </el-table-column>
            <el-table-column
              prop="regurl"
              label="公司注册地址"
              align="center"
              width="200">
            </el-table-column>
            <el-table-column
              prop="bankName"
              label="开户银行名称"
              align="center"
              width="200">
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            width="150">
            <template slot-scope="scopeDelete">
              <el-button type="warning" size="mini" round @click="reviseInvoice(scopeDelete.row)">修改</el-button>
              <el-button type="danger" size="mini" round @click="deleteInvoice(scopeDelete.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        </div>
        
        <el-row>
            
            <el-dialog
            :title="this.newOrRevise"
            :visible.sync="dialogVisible"
            :close-on-click-modal=false
            width="40%"
            :show-close=false
            >
            <el-form ref="form" :rules="rules" :model="form" label-width="100px" class="formStyle">
                    <el-form-item label="发票类型" prop="type">
                      <el-radio-group v-model="form.type" :disabled="this.radioDisabled">
                        <el-radio :label="1">普通发票</el-radio>
                        <el-radio :label="2">电子发票</el-radio>
                        <el-radio :label="3">增值税专用发票</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="发票信息" v-if="(form.type==3 ? false : true)" prop="resource">
                      <el-radio-group v-model="form.resource" :disabled="this.radioDisabled">
                        <el-radio :label="0">个人</el-radio>
                        <el-radio :label="1">企业</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item label="发票抬头" prop="title">
                      <el-input v-model="form.title"></el-input>
                    </el-form-item>
                    <el-form-item label="收票人手机号" prop="phone">
                       <el-input v-model="form.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="纳税人识别号" v-if="(form.resource==1 ? true : false)||(form.type==3 ? true : false)" prop="tin"> 
                        <el-input v-model="form.tin"></el-input>
                    </el-form-item>
                    <el-form-item label="公司注册地址" v-if="form.type==3 ? true : false" prop="regurl">
                        <el-input v-model="form.regurl"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行名称" v-if="form.type==3 ? true : false" prop="bankName">
                        <el-input v-model="form.bankName"></el-input>
                    </el-form-item>
                    <el-form-item label="开户银行账号" v-if="form.type==3 ? true : false" prop="bankAccount">
                        <el-input v-model="form.bankAccount"></el-input>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelInvoive">取 消</el-button>
                <el-button type="primary" @click="addInvoice(form)">确 定</el-button>
            </span>
            </el-dialog>
        </el-row>
    </div>
  </template>
  
  <script>
    import {
        queryMyInvoiceUrl,
        getInvoiceDetailUrl,
        addInvoiceUrl,
        deleteInvoiceUrl,
        updateInvoiceUrl,
        
    } from "@/api/api";
    import { mapState } from "vuex";
  export default {
    name: "AddressSetting",
    data() {
      return {
        invoiceList:[],
        dialogVisible: false,
        resource: 0,
        newOrRevise:"新建发票信息",
        loading:true,
        id:'',
        radioDisabled:false,
        form: {
          type:1,
          resource: 0,
          title:'',
          phone:'',
          tin:'',
          regurl:'',
          bankName:'',
          bankAccount:'',
        },
        rules: {
          title: [
            { required: true, message: '请输入发票抬头', trigger: 'blur' },
          ],
          tin: [
            { required: true, message: '请输入纳税人识别号', trigger: 'blur' },
          ]
          }
        };
    },
    computed: {
    ...mapState(["userInfo"]),
  },
    mounted() {
    this.getInvoice();
    },
    methods: {
      addSuccess() {
        this.$alert("添加成功", {
          center: true,
          showClose: false,
        }).then(() => {});
      },
      addInvoicebut(form){
        // console.log("aaa");
        this.id='';
        this.newOrRevise="新增发票信息"
        this.form.title='';
        this.form.phone='';
        this.form.tin='';
        this.form.regurl='';
        this.form.bankName='';
        this.form.bankAccount='';
        this.form.type=1;
        this.id='';
        
        this.dialogVisible=true;
        this.form.resource=0;
        
  
      },
      cancelInvoive(form){
        // this.loading=false;
        this.form.title='';
        this.form.phone='';
        this.form.tin='';
        this.form.regurl='';
        this.form.bankName='';
        this.form.bankAccount='';
        
        this.id='';
        this.radioDisabled=false;
        this.dialogVisible=false;
        // this.form.type=1;
      },
      addInvoice(form){
        this.$refs.form.validate(valid => {
        if (valid) {
             //如果通过验证 to do...
            if(this.form.title.trim()!=""){
            this.loading=true;
            console.log(this.id)
            if(this.id==''){
              var url = addInvoiceUrl;
            }else{
              var url = updateInvoiceUrl;
            }
            
            // let formData={
            //   type:'',
            //   title:'',
            //   phone:'',
            //   tin:'',
            //   regurl:'',
            //   bankName:'',
            //   bankAccount:'',
            //   access_token: this.userInfo.access_token,
            // }=this.form
            let data = {
                type:this.form.type,
                title:this.form.title.trim(),
                phone:this.form.phone.trim(),
                tIN:this.form.tin.trim(),
                regurl:this.form.regurl.trim(),
                bankName:this.form.bankName.trim(),
                bankAccount:this.form.bankAccount.trim(),
                access_token: this.userInfo.access_token,
                id:this.id,
            };
            let param = new URLSearchParams();
            for (var k in data) {
                param.append(k, data[k]);
            }
            this.$axios({
                method: "post",
                data: param,
                url,
            })
            .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
                let { data } = res.data;
                this.invoiceList=data;
                this.form.title='';
                this.form.phone='';
                this.form.tin='';
                this.form.regurl='';
                this.form.bankName='';
                this.form.bankAccount='';
                // this.form.type=1;
                this.id='';
                this.radioDisabled=false;
                
                this.dialogVisible = false;
                this.resource=0;
                
                this.getInvoice();
            } else {
                this.$alert(res.data.resultMsg);
            }
          
            })
          }else{
            this.$alert("请输入发票抬头");
            return false
          }
        } else {
          // this.$alert("请输入发票抬头");
          return false
        }
      })
      },
      reviseInvoice(row,form){
       
        this.newOrRevise="修改发票信息";
        this.radioDisabled=true;
        console.log(row)
        this.dialogVisible = true;
        console.log(row.type)
        this.$nextTick(()=>{
          this.$refs.form.resetFields();
          this.$refs['form'].resetFields();
          // console.log("测试重置")
          this.form.title=row.title;
          this.form.phone=row.telephone;
          this.form.tin=row.tin;
          this.form.regurl=row.regurl;
          this.form.bankName=row.bankName;
          this.form.bankAccount=row.bankAccount;
          this.form.type=row.type;
          console.log(row.type)
          this.id=row.id;
          if(row.tin.trim()==""){
            this.form.resource=0
            console.log("0000000000")
          }else{
            this.form.resource=1
            console.log(row.tin)
          }
        })   
      },
      deleteInvoice(val){
        
        this.$confirm('此操作将删除该发票, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        //   type: 'warning'
        }).then(() => {
            this.loading=true;
            let url = deleteInvoiceUrl;
            let id=val.id
            let data = {
                access_token: this.userInfo.access_token,
                id
            };
            let param = new URLSearchParams();
            for (var k in data) {
                param.append(k, data[k]);
            }
            this.$axios({
                method: "post",
                data: param,
                url,
            })
            .then((res) => {
            console.log(res);
            if (res.data.resultCode == 1) {
                let { data } = res.data;
                console.log("dataf", data);
                this.loading=false;
                this.getInvoice();
                this.$message({
                type: 'success',
                message: '删除成功!'
            });
            } else {
                this.$alert(res.data.resultMsg);
                this.loading=false;
            }
            })
            .catch((err) => {
            this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
            });
            this.loading=false;
          
        }).catch(() => {
          this.loading=false;
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
        
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
            this.loading=false;
          })
          .catch(_ => {});
      },
      getInvoice(){
        console.log("aaaaa");
        let that = this;
        let url = queryMyInvoiceUrl;
        let data = {
            access_token: this.userInfo.access_token,
        };
        let param = new URLSearchParams();
        for (var k in data) {
            param.append(k, data[k]);
        }
        this.$axios({
            method: "post",
            data: param,
            url,
        })
        .then((res) => {
        console.log(res);
        if (res.data.resultCode == 1) {
            let { data } = res.data;
            // console.log("dataf", data);
            this.invoiceList=data;
            this.loading=false;
        } else {
            this.$alert(res.data.resultMsg);
        }
        })
        .catch((err) => {
        this.$alert(err ? JSON.stringify(err) : "网络异常，请稍后重试");
        });

    }
    },
     
  };
  </script>
  
  <style scoped>
      .buttonFloat{
          float: left;
          margin-left: 30px;
      }
  </style>
  <style>
    .invoiceTable .el-dialog__body{
      margin: 0 40px!important;
    }
    .invoiceTable .el-form-item__label{
      padding-right: 25px!important;
    }
    .invoiceTAable y.el-table--fit{
      margin-left: 20px!important;
    }
    .radioDisabled{
      cursor:pointer;
    }
    .el-radio:hover{
      cursor:pointer;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/SettingPage/components/InvoiceControl.vue